import { Market } from 'BrokerTsLib/src/enums'
import type { IPartnerSettings } from '.'


export const RLCZ: IPartnerSettings = {
  partner: 'RLCZ',
  hosts: [
    'czrlpa-cebap2.raiffleas.cz',
    'czrlpa-cebap1.raiffleas.cz'
    //  , 'localhost:44470'
  ],
  market: Market.CZ
}
